module.exports = __webpack_public_path__ + "static/media/tool_logo_appscan.9b037d8b.png";